import { Gender } from '@/shared/api-client/enums/gender';
import { ICandidate } from '@/shared/api-client/models/candidate';
import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GenderIconComponent extends Vue {

    @Prop() public candidate!: ICandidate;
    @Prop() public gender!: Gender;
    @Prop() public show!: boolean;

    /**
     *
     */
    constructor() {
        super();
    }

    public get val(): Gender {

        if (this.candidate && this.candidate.userData !== undefined && this.candidate.userData.gender !== undefined) {

            return this.candidate.userData.gender;
        }

        if (this.gender !== undefined) {
            return this.gender;
        }

        return 'Undefined';
    }
}
